<!-- 物业角色管理-->
<template>
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="roleId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-switch @change="onChange($event, row.roleName,row.roleId)" :checked="Number(row.status) ? true : false"/>
      </template>
    </x-tabula>

    <!--添加角色的弹窗-->
    <a-modal
      width="700px"
      :title="modalTitle"
      :visible="visible"
      :footer="null"
      @ok="isSubmit = true"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      ref="form"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
      :defaultCheckedKeys="defaultCheckedKeys"
    >
    </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'propertyRole',
  data () {
    return {
      modalTitle: '添加角色',
      visible: false,
      defaultCheckedKeys: [],
      btnLoading: { loading: false },
      // 表单参数
      addParam: {
        url: '/role/property',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/role/property/',
        resHandle: this.addResHandle
      },
      detailParam: {
        url: '', // /room/
        resHandle: this.detailResHandle
      },
      formKey: {
        roleName: '',
        roleKey: '',
        roleSort: '',
        status: '',
        menuIds: '',
        remark: ''
      },
      formList: [
        {
          label: '角色名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色名称',
          props: ['roleName', {
            rules: [
              { required: true, message: '请输入角色名称' }
            ]
          }]
        },
        {
          label: '权限字符',
          inputType: 'input',
          options: [],
          placeholder: '请输入权限字符',
          props: ['roleKey', {
            rules: [
              { required: true, message: '请输入权限字符' }
            ]
          }]
        },
        {
          label: '角色顺序',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色顺序',
          props: ['roleSort', {
            rules: [
              { required: true, message: '请输入角色顺序' },
              { pattern: /^\d*$/, message: '请输入数字' },
              { min: 1, max: 4, message: '最多4位数' }
            ]
          }]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: [{label: '正常', value: 1}, {label: '停用', value: 0}],
          placeholder: '请输入权限字符',
          props: ['status', {
            rules: [
              { required: true, message: '请输入权限字符' }
            ],
            initialValue: 0
          }]
        },
        {
          disabled: false,
          label: '菜单权限',
          inputType: 'treeSearch',
          options: [],
          handle: '',
          isSearch: false,
          placeholder: '请选择',
          props: ['menuIds', {
            rules: [
              { required: true, message: '请设置菜单权限' }
            ]
          }]
        },
        {
          label: '备注',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入备注',
          props: ['remark', {
            rules: []
          }]
        }
      ],
      searchList: [
        { props: ['roleName'], placeholder: '角色名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:role:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:role:remove'] }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.openModal(row), permi: ['community:role:edit'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:role:remove'] }
      ],
      columns: [
        { title: '角色名称', dataIndex: 'roleName', align: 'left', width: '' },
        { title: '权限字符', dataIndex: 'roleKey', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '创建人', dataIndex: 'createBy', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        roleName: undefined
        // status: undefined
        // create_date: undefined
      },
      listApi: {
        url: '/role/property/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: 'role/',
        param: {},
        title: '角色',
        key: 'roleName'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/menu/property/treeselect'
      }).then(res => {
        this.recursionList(res.data);
        this.formList[4].options = res.data;
      });
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    /* 打开弹窗 */
    openModal (row) {
      this.visible = true;
      let title = '';
      if (row.roleId) {
        title = '修改角色';
        let url = `/role/${row.roleId}`;
        this.$nextTick(() => {
          this.$refs.form.getDetail(url);
          this.$refs.form.routeQuery = row.roleId;

          this.$get({
            url: `/menu/roleMenuTreeselect/${row.roleId}`
          }).then(res => {
            this.$refs.form.defaultTree = res.data.checkedKeys;
            this.$refs.form.treeCheck(res.data.checkedKeys, 'menuIds');
            if (row.roleId === '1') {
              this.formList[4].disabled = true;
            } else {
              this.formList[4].disabled = false;
            }
          });
        });
      } else {
        title = '新增角色';
      }
      this.modalTitle = title;
    },
    onChange (checked, name, id) {
      let title = `确认要${checked ? '启用' : '停用'}"${name}"角色吗?`;
      this['$confirm']({
        title,
        okType: 'danger',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          this.$put({
            url: `/role/property/changeStatus/${id}`,
            params: {
              status: checked ? 1 : 0
            }
          }).then(res => {
            this.$message.success(res.msg);
            this.$refs.table.getTableList();
          });
        }
      });
    },
    // 弹窗表单返回结果
    addResHandle (res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
        this.visible = false;
      }
    },
    detailResHandle (res) {
      res.status = Number(res.status);
      return res;
    },
    // 添加角色
    reqHandle (res) {
      let choseList = res.menuIds;
      let arr = this.findFatherNode(choseList);
      res.menuIds = arr;
      return res;
    },
    findFatherNode (list) {
      let arr = [];
      this.formList[4].options.forEach(item1 => {
        if (list.includes(item1.value)) {
          arr.push(item1.value);
        }
        if (item1.children && item1.children.length) {
          item1.children.forEach(item2 => {
            if (list.includes(item2.value)) {
              arr.push(item2.value);
              arr.push(item1.value);
            }
            if (item2.children && item2.children.length) {
              item2.children.forEach(item3 => {
                if (list.includes(item3.value)) {
                  arr.push(item3.value);
                  arr.push(item2.value);
                  arr.push(item1.value);
                }

                if (item3.children && item3.children.length) {
                  item3.children.forEach(item4 => {
                    if (list.includes(item4.value)) {
                      arr.push(item4.value);
                      arr.push(item3.value);
                      arr.push(item2.value);
                      arr.push(item1.value);
                    }
                  });
                }
              });
            }
          });
        }
      });
      arr = [...new Set(arr)];
      return arr;
    },
    resHandle (res) {
      return res.rows;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
